import {
  EventNames,
  FirebaseCommonEventNames,
} from '@unu/ui-enums';

export const FirebaseWebEventNames = {
  ...FirebaseCommonEventNames,
  [EventNames.ExternalLinkClick]: 'click',
  [EventNames.FileDownload]: 'file_download',
  [EventNames.FormEdit]: 'form_start',
  [EventNames.FormSubmit]: 'form_submit',
  [EventNames.ScreenView]: 'page_view',
  [EventNames.Scroll]: 'scroll',
  [EventNames.SiteSearch]: 'view_search_results',
  [EventNames.VideoComplete]: 'video_complete',
  [EventNames.VideoProgress]: 'video_progress',
  [EventNames.VideoStart]: 'video_start',
};